/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractFinderGridDefinition, ROW_GROUP_CLASS } from '@gh/common-internal-shared';
import { TranslationService } from '@gh/core-mls';
import { gridValueCollectionComparator } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';
import { merge } from 'lodash';
import {
  accountCodeComparator,
  AccountingAccount,
  accountNameComparator,
  getAccountingAccountId,
} from '../../../resources';

@Injectable()
export class AccountingAccountDialogGridDefinitionService extends AbstractFinderGridDefinition {
  getId = getAccountingAccountId;

  constructor(private translationService: TranslationService) {
    super();
  }

  buildGridOptions(): GridOptions {
    return merge(
      super.buildGridOptions(),
      {
        rowClassRules: {
          [ROW_GROUP_CLASS]: ({ data }: { data: AccountingAccount }) => data && data.groupTitle || false,
        },
      });
  }

  buildColumnDefs(): ColDef[] {
    return [
      {
        field: 'code',
        headerName: this.translationService.get('lbl_name'),
        width: 20,
        comparator: this.codeSorting,
      },
      {
        field: 'name',
        headerName: this.translationService.get('lbl_description'),
        width: 80,
        comparator: this.nameSorting,
      },
    ];
  }
  codeSorting(codeA: string, codeB: string): number {
    if (!codeA && !!codeB) {
      return -1;
    } else if (!!codeA && !codeB) {
      return 1;
    } else if (!codeA && !codeB) {
      return 0;
    }
    const a = parseInt(codeA);
    const b = parseInt(codeB);
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    return 0;
  }

  nameSorting(nameA: string, nameB: string): number {
    const a = nameA.toLowerCase();
    const b = nameB.toLowerCase();
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    return 0;
  }
}
